if (!customElements.get('product-modal')) {
    customElements.define(
      'product-modal',
      class ProductModal extends ModalDialog {
        constructor() {
          super();
        }
  
        hide() {
          super.hide();
        }
  
        show(opener) {
          super.show(opener);
          this.showActiveMedia();
        }

        showActiveMedia() {
          this.querySelectorAll('img').forEach(image => image.removeAttribute('loading'))
          this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
              element.classList.remove('active');
            }
          )
          let activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
          let dataMediaAlt = activeMedia.dataset.mediaAlt
          this.querySelectorAll(`[data-media-alt]`).forEach(element => element.classList.remove('product__media-item--variant-alt'))
          this.querySelectorAll(`[data-media-alt="${dataMediaAlt}"]`).forEach(element => element.classList.add('product__media-item--variant-alt'))
          let activeMediaTemplate = activeMedia.querySelector('template');
          let activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
          activeMedia.classList.add('active');
          activeMedia.scrollIntoView();
    
          let container = this.querySelector('[role="document"]');
          container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;
    
          if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube')) activeMedia.loadContent();
          document.dispatchEvent(new CustomEvent('image:show'));
        }
      }
    );
  }